export default import.meta.ROLLDOWN_FILE_URL_OFZOUfxifiFQJ1R3kVJviA